import React, { useState } from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import { emailSubsFormValidationSchemaForCampaingAndFooterModal, emailSubsFormValidationSchemaForInAppMessage } from '../../../../validationSchemas/contactUsSchema';
import { FormField } from '../../../FormFields/FormField';
import { Link } from 'react-router-dom';
import { getUser, isIOSDevice } from '../../../../helpers/helperMethods';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import { CUSTOMER_MICRO_SERVICE, REACT_APP_CLOUD_FRONT, ROUTE_MENU } from '../../../../constants';
import { Toast_Func } from '../../../../helpers/toast.helper';
import Spinner from '../../../Spinner/Spinner';
import axiosWithInterceptor from '../../../../services/axiosWithInterceptor';
import Parser from 'html-react-parser';
import Confirmation from '../../../confirmation/Confirmation';
import Button from '../../../Buttons/Button';
import styleClasses from '../../../Footer/Popup.module.scss';

const Confirmation_data = {
  section_title: 'THANK YOU!',
  section_details: 'You are now on our mailing list.'
};

export default function EmailSubscription(props) {
  const { inAppMessage, handleModalClose } = props;
  const { extras } = inAppMessage;

  const isItMobile = useCheckMobileScreen();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setButtonLoading(true);
    try {
      const user = getUser();
      const payload = {
        ...extras,
        encoded_cz_id: user.encoded_cz_id,
        source: isItMobile ? 'Mobile Web' : 'Web',
        email: values.email,
      };
      await axiosWithInterceptor.post(
        `${CUSTOMER_MICRO_SERVICE}/loyalty/campaign-trigger`,
        payload
      );
      setShowConfirmationModal(true);
    } catch (error) {
      Toast_Func({
        status: false,
        message: error?.response?.data?.message,
      });
    } finally {
      setSubmitting(false);
      setButtonLoading(false);
    }
  };

  const initialFormState = {
    email: '',
  };
  return (
      <Row>
        <Col xs="12" sm="12" md="6">
          <Modal
            className={`${isIOSDevice() && styleClasses.modal_box_for_ios} ${styleClasses.modal_box} footer-modal-wrap new_form_design 
            theme-modal-style   border-radius-15 order_type_modal`}
            show={inAppMessage}
            onClose={handleModalClose}
            backdrop="static"
            tabIndex="-1"
            keyboard={false}
            aria-labelledby="Newsletter2"
            aria-describedby="Description2"
            aria-label="close_button2"
            id="notes2"
            centered
            style={
              {
                "--modal-bg-desktop": `url(${REACT_APP_CLOUD_FRONT}/images/Home/pool-desktop.png)`,
                "--modal-bg-mobile": `url(${REACT_APP_CLOUD_FRONT}/images/Home/pool-mobile.png)`,
              } as React.CSSProperties
            }
          >
            <Modal.Header className="" id="close_button2">
              <button
                className={`${styleClasses.modal_close_button} btn modal-close-button p-0`}
                onClick={handleModalClose}
                aria-controls="notes2"
              >
                Close
              </button>
            </Modal.Header>
            <Modal.Body
              className="app_container_wrap px-1 pb-4 pt-md-5 pt-3 ps-md-5"
              id="Description2"
            >
              <Container>
                {showConfirmationModal ? (
                  " "
                ) : (
                  <Row>
                    <Col xs="12" sm="12">
                      <h5
                        id="Newsletter2"
                        className="font-ticketing text-uppercase fw-normal pb-md-3 pb-4 mb-2"
                      >
                      {isItMobile ? (<>let's be <br /> inbox besties</>) : ('inbox besties?')}
                      </h5>
                      <p
                        className={`${styleClasses.modal_description} font-helvetica-light mb-2 pb-md-3 pb-4 px-md-0 px-3`}
                      >
                        {
                        isItMobile ? 
                        'Be the first to know about fire menu drops and fresh deals. All it takes is your email.' 
                        : 
                        'Wanna be first to know about fire menu drops and fresh deals? All it takes is your email.'
                        }
                      
                      </p>
                    </Col>
                  </Row>
                )}
                {showConfirmationModal ? (
                  <Confirmation Confirmation_data={Confirmation_data} />
                ) : (
                  <Row>
                    <Col xs="12" sm="12" >
                      <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialFormState}
                        validationSchema={emailSubsFormValidationSchemaForCampaingAndFooterModal}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                          isSubmitting,
                        }) => (
                          <React.Fragment>
                            <form onSubmit={handleSubmit}>
                              <Row>
                                <Col md={12} xs={12} className="text-start">
                                  <FormField
                                    name="email"
                                    type={"text"}
                                    value={values.email}
                                    onChange={handleChange}
                                    placeholder={extras?.input_placeholder_text ?? "Email address"}
                                    errors={errors}
                                    touched={touched}
                                  />
                                </Col>
                              </Row>
                              <Row className="mb-4">
                                <Col>
                                  <Button
                                    className={`${styleClasses.signup_button} font-helvetica-heavy`}
                                    disabled={isSubmitting || buttonLoading}
                                    type="submit"
                                    loading={buttonLoading}
                                  >
                                    <span>{extras?.button_title ?? "sign me up"}</span>
                                  </Button>
                                </Col>
                              </Row>
                            </form>
                          </React.Fragment>
                        )}
                      </Formik>
                    </Col>
                  </Row>
                )}
              </Container>
            </Modal.Body>
          </Modal>
        </Col>
      </Row>
  );
}
